export default __webpack_public_path__ + "static/media/upArrow.dc88baa8.svg";